import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-activity-type-dev-types',
  templateUrl: './activity-type-dev-types.component.html',
  styleUrls: ['./activity-type-dev-types.component.css']
})
export class ActivityTypeDevTypesComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public itemsListDeviationTypes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(1234, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadDeviationTypes() {
        if (!this.setting) return;

        return this.itemsListDeviationTypes = await this.datatask.Post(1235, {
            argtype: this.setting.argtype,
            argvalue: this.setting.argvalue
        });
    }

    private async init() {
        await this.loadSetting();
        this.loadDeviationTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    argtype: string;
    argvalue: string;
    page_heading: string;
}
